<template>
	<div class="selectGift">
		<el-dialog title="选择产品" :visible.sync="dialogTableVisible">
			<div>
				<div class="overFix">
					<span>产品分类：</span>
					<el-radio-group
						v-model="deductType"
						class="radios"
						@change="radioChange"
					>
						<el-radio label="">全部产品</el-radio>
						<el-radio
							v-for="(item, index) in options"
							:key="index"
							:label="item.id"
							>{{ item.name }}</el-radio
						>
					</el-radio-group>
				</div>
			</div>
			<el-table
				ref="multipleTable"
				:data="list"
				max-height="500px"
				@selection-change="handleSelectionChange"
				@select="select"
				header-cell-class-name="table_header_bgcolor"
			>
				<el-table-column
					prop="name"
					label="商品名称"
					width="auto"
				></el-table-column>
				<el-table-column
					prop="salePrice"
					label="价格"
					width="100"
				></el-table-column>
				<el-table-column type="selection" width="55"> </el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="calcel">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
	data() {
		return {
			dialogTableVisible: false,
			list: [],
			query: {
				size: 20,
				name: '',
			},
			form: {},
			selectList: [],
			deductType: '',
			options: [],
			deleteRow: {},
			//合并行
		}
	},
	mixins: [minxin],
	components: {},
	created() {
		this.init()
	},
	mounted() {
		//this.getTableArr();
	},
	watch: {},
	methods: {
		init() {
			this.$on('set', function(org) {
				console.log('org: ', JSON.parse(JSON.stringify(org)))
				this.dialogTableVisible = true
				// this.selectList = JSON.parse(JSON.stringify(org));
				this.getCategroy()
				this.data()
			})
		},
		getCategroy() {
			this.$api.get(this.$url.giftOrderInfo.listCategory).then((res) => {
				this.options = res
			})
		},
		radioChange(value) {
			this.selectList = []
			this.$refs.multipleTable.clearSelection()
			this.data(value)
		},

		data(id) {
			this.$api
				.post(this.$url.giftOrderInfo.listByTime, {
					categoryId: id ? id : '',
				})
				.then((res) => {
					if (res) {
						this.list = res
						this.$nextTick(() => {
							this.selectList.forEach((row) => {
								this.list.forEach((item) => {
									if (row.id == item.id) {
										item.itemNum = row.itemNum
										item.staffIds = row.staffIds
										item.staffNames = row.staffNames
										item.name = row.name
										this.$refs.multipleTable.toggleRowSelection(
											item,
											true
										)
									}
								})
							})
						})
					}
				})
		},
		handleSelectionChange(val) {
			this.selectList = this.selectList.concat(val)
			console.log(this.deleteRow.id)
			let obj = {}
			let arr = this.selectList.reduce((cur, next) => {
				obj[next.id] ? '' : (obj[next.id] = true && cur.push(next))
				return cur
			}, []) //设置cur默认类型为数组，并且初始值为空的数组
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].id == this.deleteRow.id) {
					arr.splice(i, 1)
					this.deleteRow = {}
				}
			}
			// this.selectList.forEach((item,index)=> {

			// })
			this.selectList = arr
		},
		calcel() {
			this.deductType = ''
			this.selectList = []
			this.dialogTableVisible = false
		},
		select(selection, row) {
			var result = selection.some((item) => {
				if (item.id == row.id) {
					return true
				}
			})

			if (!result) {
				// 如果不存在
				this.deleteRow = row
				// do something
			}
		},
		confirm() {
			if (this.selectList.length == 0) {
				return this.$message.error('请勾选至少一个商品')
			}

			this.$emit('changeGift', this.selectList)
			this.selectList = []
			this.deductType = ''
			this.dialogTableVisible = false
		},
	},
}
</script>

<style lang="less" scoped>
.overFix {
	padding: 10px 5px;
}
.selectGift {
	/deep/ .el-dialog__header {
		padding: 10px;
	}
	/deep/ .el-dialog__body {
		padding: 0 10px;
	}
}
</style>
